import { css } from "styled-components";
const veciTabsMobileStyles = {
    TabsStyled: ()=>css`
		--primary-list-border-bottom-color: ${({ theme  })=>theme.colors.green?.darker};
		--primary-button-color: ${({ theme  })=>theme.colors.grays.darker};
		--primary-active-background: ${({ theme  })=>theme.colors.green?.darker};
		--primary-active-border-bottom-color: ${({ theme  })=>theme.colors.green?.darker};
		--primary-active-color: ${({ theme  })=>theme.colors.white.base};
	`
};
export default veciTabsMobileStyles;

//# sourceMappingURL=veci.js.map